import { FC } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { ResourceExplorerBudget } from "./ResourceExplorerBudget";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerIdSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resourceExplorerIdSelector";
import { resourceExplorerByIdLoadingSelector } from "@/store/resource-explorer/selectors/resource-explorer-by-id/resourceExplorerByIdLoadingSelector";
import { Budget } from "@/services/cloudchipr.api";

export const ResourceExplorerBudgets: FC<{
  budget: Budget;
}> = ({ budget }) => {
  const viewId = useAppSelector(resourceExplorerIdSelector);

  const isLoading = useAppSelector((state) =>
    resourceExplorerByIdLoadingSelector(state, viewId),
  );

  return (
    <Stack>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <ResourceExplorerBudget budget={budget} withPopover />
      )}
    </Stack>
  );
};
